import React, { useCallback, useEffect, useRef } from 'react';
import { useEvent } from '../../../../contexts/event-bus';
import WorkspaceItemContext from '../../../../contexts/workspace/workspace-item-context';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { WorkspaceStateItem } from '../../../../state/slices/workspace-slice';
import { patchFocusedWorkspace, patchWorkspace, store } from '../../../../state/store';
import { useWorkspace } from '../../hooks/use-view';

export function FlightForward() {
    const isFlightSelected = !!useWorkspace((x) => x.flights.selected[0]);
    const previousFlightSettings = useRef<WorkspaceStateItem['flights']['settings'] | null>(null);
    const context = React.useContext(WorkspaceItemContext);
    const forward = useWorkspace((x) => x.flights.fastForward);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (forward.active) {
            previousFlightSettings.current = store.getState().workspace.items[context.id].flights.settings;
            dispatch(
                patchFocusedWorkspace((w) => {
                    w.flights.settings.encompass = true;
                    w.flights.settings.focus = true;
                    w.flights.settings.flightPlan.show = true;
                    w.flights.settings.flightPlan.showAtc = true;
                    w.flights.settings.flightPlan.showPlanned = true;
                })
            );
            context.flightLayerFacade.deckPlugin.flightForwardProps = {
                show: true,
                flightId: forward.flightId,
                iconType: forward.icon
            };

            const firstPoint = forward.points?.[0];
            if (firstPoint && forward.points && forward.points?.length >= 3) {
                context.flightLayerFacade.deckPlugin.flightForwardFlight = {
                    index: 0,
                    position: firstPoint.position,
                    altitude: firstPoint.altitude,
                    time: firstPoint.time,
                    heading: firstPoint.heading
                };
            } else {
                context.flightLayerFacade.deckPlugin.flightForwardFlight = null;
            }
        } else {
            const previous = previousFlightSettings.current;
            if (previous) {
                const current = store.getState().workspace.items[context.id].flights.settings;
                dispatch(
                    // prettier-ignore
                    patchWorkspace(context.id, (w) => {
                        w.flights.settings.encompass = resetIfShould(previous.encompass, current.encompass, false)
                        w.flights.settings.focus = resetIfShould(previous.focus, current.focus, false)
                        w.flights.settings.flightPlan.show = resetIfShould(previous.flightPlan.show, current.flightPlan.show, false)
                        w.flights.settings.flightPlan.showAtc = resetIfShould(previous.flightPlan.showAtc, current.flightPlan.showAtc, false)
                        w.flights.settings.flightPlan.showPlanned = resetIfShould(previous.flightPlan.showPlanned, current.flightPlan.showPlanned, false)
                    })
                );
            }
            context.flightLayerFacade.deckPlugin.flightForwardProps = {
                show: false
            };
        }

        context.flightLayerFacade.deckPlugin.updateLayers();
    }, [forward]);

    useEffect(() => {
        if (forward.active && !isFlightSelected) {
            dispatch(patchFocusedWorkspace((x) => (x.flights.fastForward = { active: false })));
        }
    }, [forward, isFlightSelected]);

    useEvent(
        'fast-forward-progress',
        useCallback(
            (progress) => {
                if (forward.active) {
                    const current = forward.points ? forward.points[progress] : null;
                    if (current) {
                        context.flightLayerFacade.deckPlugin.flightForwardFlight = {
                            index: progress,
                            position: current.position,
                            altitude: current.altitude,
                            time: current.time,
                            heading: current.heading
                        };
                    }
                }
                context.flightLayerFacade.deckPlugin.updateLayers();
            },
            [context, forward]
        )
    );

    return <></>;
}

function resetIfShould(previous: boolean, current: boolean, value: boolean): boolean {
    if (previous === value) {
        return value;
    }

    return current;
}
